import { Popover } from 'antd';

import classnames from 'classnames';

import './OriginValuePopover.less';

const OriginValuePopover = (props) => {
  const { children, showHighLight, hightlightStyle, originValueRender } = props;

  return (
    <Popover
      content={originValueRender}
      title='Origin Value'
      overlayStyle={{ maxWidth: 500 }}
      style={{ maxWidth: '100%' }}
      overlayInnerStyle={{ maxWidth: '100%' }}
    >
      <div
        className={classnames('overlay-value-item', {
          'overlay-value-item--highlight': showHighLight,
        })}
        style={showHighLight ? hightlightStyle ?? {} : {}}
      >
        {children && children}
      </div>
    </Popover>
  );
};

export { OriginValuePopover };
